<template>
  <MapboxLayer
      v-bind:name="name"
      v-bind:beforeLayerName="beforeLayerName"
      v-bind:layers="layers"
      v-bind:geoJSON="geoJSON"
      v-bind:interactivity="interactivity"
      v-bind:clusterSettings="clusterSettings"
      v-on:featureClick="$emit('featureClick', $event)"
  />
</template>
<script>
import MapboxLayer from './MapboxLayer'
import {queryFeatures} from '@esri/arcgis-rest-feature-service'
import * as turf from 'turf'

export default {
  name: 'ArcRestLayer',
  components: {MapboxLayer},
  props: [
    'name',
    'beforeLayerName',
    'requestOptions',
    'requestGeomOptions',
    'layers',
    'interactivity',
    'clusterSettings',
    'join_column',
    'data_columns',
  ],
  data: function () {
    return {
      geoJSON: {
        type: 'FeatureCollection',
        features: [],
      },
    }
  },
  computed: {
    map: function () {
      return this.$parent.map
    },
  },
  methods: {
    getFeatures() {
      if (this.requestGeomOptions) {
        queryFeatures(this.requestGeomOptions)
            .then((geom_response) => {
              let geoms = turf.featureCollection(geom_response.features)
              if (this.requestOptions) {
                queryFeatures(this.requestOptions)
                    .then((response) => {
                      let data_lookup = {}
                      response.features.forEach(feature => data_lookup[feature.attributes[this.join_column]] = feature.attributes)
                      geoms.features = geoms.features.map(feature => {
                            let id = feature.properties[this.join_column]
                            this.data_columns.forEach(column => {
                              if (data_lookup[id]) {
                                feature.properties[column] = data_lookup[id][column]
                              } else {
                                feature.properties[column] = 0
                              }
                            })
                            return feature
                          }
                      )
                      this.geoJSON = geoms
                    });
              }
            });
      }

    },
    // get_next(url, offset) {
    //   fetch(url + '&resultOffset=' + offset).then(r => r.json()).then(data => {
    //     if (url !== this.restURL) {
    //       // we are on an outdated chain of requests.
    //       return;
    //     }
    //     this.geoJSON = turf.featureCollection(this.geoJSON.features.concat(data.features))
    //     if (data.exceededTransferLimit) {
    //       this.get_next(url, this.geoJSON.features.length)
    //     }
    //   })
    // },
  },
  watch: {
    requestOptions: {
      immediate: true,
      handler() {
        this.getFeatures()
      },
    },
    requestGeomOptions: {
      immediate: true,
      handler() {
        this.getFeatures()
      },
    },
  },
}
</script>

<style scoped>

</style>
